/**
 * Copyright Aquera Inc 2026
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

export const styles = css`
  :host {
    box-sizing: border-box;
    display: block;
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  .item {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 40px;
    padding: var(--nile-spacing-none, var(--ng-spacing-none)) var(--nile-spacing-xl, var(--ng-spacing-xl));
    font-family: inherit;
    font-size: var(--nile-type-scale-4, var(--ng-font-size-text-sm));
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-semibold));
    line-height: var(--nile-line-height-1-8, var(--ng-line-height-text-md));
    letter-spacing: normal;
    color: var(--nile-colors-text-default, var(--ng-colors-text-secondary-700));
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
    transition: 150ms fill;
  }

  .item:hover,
  .item:focus,
  .item:focus-visible {
    outline: none;
    background-color: var(--nile-colors-neutral-100, var(--ng-colors-bg-primary-hover));
    color: var(--nile-colors-dark-900, var(--ng-colors-text-secondary-hover));
  }

  .item[aria-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  .icon {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    margin-right: var(--nile-spacing-md, var(--ng-spacing-md));
  }

  .icon[data-empty='true'] {
    display: none;
  }

  .label {
    flex: 1 1 auto;
    min-width: 0;
  }

  .chevron {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    margin-left: var(--nile-spacing-md, var(--ng-spacing-md));
    line-height: 1;
    opacity: 0.6;
  }
`;

export default [styles];
